import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  OtaId,
  Platform,
} from 'frontend-utils/utils/constants/constant-values';
import type { MEMBERSHIPTYPES } from 'lumen/utils/constants/general-constants';

type MembershipType =
  | typeof MEMBERSHIPTYPES.PUBLIC
  | typeof MEMBERSHIPTYPES.MEMBER_ONLY
  | typeof MEMBERSHIPTYPES.COUPON;

export default class ParityScreenshotParity extends Model {
  [Type] = 'parity/screenshot-parity' as const;

  @attr('string') declare channel: OtaId; // Used for constructing the screenshot ID
  @attr('string') declare fromDate: string;
  @attr('string') declare hotelinfoId: string; // Used for constructing the screenshot ID
  @attr('string') declare los: number;
  @attr('number') declare maxPersons: number; // Used for constructing the screenshot ID
  @attr('number') declare membershiptype: MembershipType; // Used for constructing the screenshot ID
  @attr('string') declare ota: string; // Used for constructing the screenshot ID
  @attr('string') declare period: string; // Used for constructing the screenshot ID
  @attr('number') declare platform: Platform; // Used for constructing the screenshot ID
  @attr('string') declare pos: string; // Used for constructing the screenshot ID
  @attr('string') declare screenshotUrl: string;
}
